module.exports = __webpack_public_path__ + "media/fonts/NettoOT-Bold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/NettoOT-Bold.otf
// module id = 42
// module chunks = 0